import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { GlobalConstants } from 'app/shared/constants/globalconstants';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';

import { AppStateInterface } from '../../app-config/state/models';
import { RestConnectorService } from '../../connector-services/rest-connector-service/rest-connector-service.abstract';

@Injectable({
  providedIn: 'root',
})
export class DefaultLanguageStringsService extends RestConnectorService {

  public defaultStringArray: any;
  public defaultLanguageCulture: string = 'en';
  constructor(private readonly _httpClient: HttpClient, public _GlobalConstants: GlobalConstants,
              protected readonly _store: Store<AppStateInterface>) {
    super(_store);
    this.defaultStringArray = this.getDefaultLanguageStrings();
  }

  public loadDefaultLanguageStrings(): Observable<{ [key: string]: string }> {
    return this._httpClient.get<{ [key: string]: string }>(
      '/api/language-strings/' + this.defaultLanguageCulture,
      { observe: 'response' },
    )
      .pipe(
        map((httpResponse: HttpResponse<{ [key: string]: string }>) => {
          return <{ [key: string]: string }>httpResponse.body;
        }),
      );
  }

  public setDefaultLanguageStrings(data: any): void {
    this._GlobalConstants.default_strings = JSON.stringify(data);
    this.defaultStringArray = data;
  }

  public getDefaultLanguageStrings(): any {
    return this._GlobalConstants.default_strings ? JSON.parse(this._GlobalConstants.default_strings) : '';
  }
}
